<div *ngIf="init">
  <mat-card class="top-card mat-elevation-z0 overflowHidden">
    <div
      [class.collapsed]="isCollapsed"
      class="section-header padding d-flex  overflowHidden clickable"
      (click)="isCollapsed = !isCollapsed"
      [attr.aria-expanded]="!isCollapsed"
    >
      <div class="invoicingTitle flexer">
        Offerte/Facturatie
      </div>
      <button
        mat-icon-button
        class="arrow-button pull-right"
        style="margin-top:5px"
      >
        <mat-icon svgIcon="arrow-up"></mat-icon>
      </button>
    </div>
    <div [collapse]="isCollapsed" [isAnimated]="!safari">
      <br />

      <div class="under-space">
        <checkbox
          [text]="'Offerte nodig'"
          [checked]="inputProject.needsQuotation"
          (answer)="setNeedsQuotation($event)"
        ></checkbox>
      </div>

      <div
        *ngIf="inputProject.needsQuotation && inputProject.quotation != null"
      >
        <div class="d-flex">
          <div>
            <div class="form-sub-title">Toegewezen aan</div>
            <mat-form-field appearance="outline">
              <mat-select
                matInput
                placeholder="Maak een keuze"
                required
                [(ngModel)]="inputProject.quotationHandler"
                name="quotationHandler"
                [compareWith]="compareEntities"
                (ngModelChange)="quotationHandlerChange()"
              >
                <mat-option
                  *ngFor="let option of quotationHandlerChoices"
                  [value]="option"
                >
                  <span *ngIf="option.user"
                    >{{ option.user.firstName }}
                    {{ option.user.lastName }}</span
                  >
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="left-space">
            <div class="form-sub-title">Deadline offerte</div>
            <mat-form-field class="first-form-field" appearance="outline">
              <input
                matInput
                [matDatepicker]="quotationByDatePicker"
                placeholder="Selecteer een datum"
                [(ngModel)]="inputProject.quotationByDate"
                (ngModelChange)="quotatationByDateChange()"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="quotationByDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #quotationByDatePicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div style="flex: 1;" class="left-space">
            <div class="form-sub-title ">Belangrijk</div>
            <button
              [ngClass]="
                inputProject.quotationImportant
                  ? 'icon-button selected-icon-button'
                  : 'icon-button non-selected-icon-button'
              "
              type="button"
              (click)="setImportantQuotation()"
              mat-button
              class="justify-items-center align-items-center"
            >
              <mat-icon>flag</mat-icon>
            </button>
          </div>
        </div>

        <div class="d-flex">
          <div style="flex: 0.75">
            <textarea-input
              [placeholder]="'Info omtrent offerte en opvolgen'"
              (answer)="quotationCommentsChange($event)"
              [initContent]="inputProject.quotationComments"
              minHeight="60px"
              rows="10"
            >
            </textarea-input>
          </div>
          <div style="flex: 0.25" class="left-space">
            <yes-no
              [title]="'Weghalen inbegrepen'"
              [flexRow]="false"
              [value]="inputProject.includeRepoInPrice"
              [neverShowExtraInstructions]="true"
              (answer)="includeRepoInPriceChange($event)"
            ></yes-no>
          </div>
        </div>

        <textarea-input
          [title]="'Opmerkingen facturatie'"
          [placeholder]="'Geef hier opmerkingen voor de facturatie'"
          [initContent]="inputProject.extraInfoInvoice"
          [sensitive]="true"
          (answer)="extraInfoInvoiceChange($event)"
        ></textarea-input>

        <textarea-input
          *ngIf="inputProject.quotation != null"
          [title]="'Mededeling voor klant'"
          (answer)="setNoteForCustomer($event)"
          [initContent]="inputProject.quotation.noteForCustomer"
          [sensitive]="true"
        >
        </textarea-input>

        <button
          class="button"
          type="button"
          mat-button
          (click)="openSendQuotationModal()"
        >
          {{ getSendQuotationLabel() }}
        </button>
        <ng-container *ngIf="inputProject.quotation.registeredActions != null">
          <div class="registered-action-display">
            <registered-action-display
              *ngFor="
                let registeredAction of inputProject.quotation.registeredActions
              "
              [inputRegisteredAction]="registeredAction"
            ></registered-action-display>
          </div>
        </ng-container>
        <div class="smaller-upper-space">
          <yes-no
            [title]="'Offerte opgevolgd'"
            [value]="inputProject.quotationFollowed"
            [neverShowExtraInstructions]="true"
            (answer)="setQuotationFollowed($event)"
          ></yes-no>
        </div>
        <div
          class="mat-form-field-project-form-margins less-upper-space quotation-approval-margin"
        >
          <yes-no
            [showExtraInstructionsOn]="'Nee'"
            [value]="inputProject.quotation.approved"
            [yesValue]="'Offerte goedgekeurd'"
            [noValue]="'Offerte afgekeurd'"
            [nullIsFalse]="false"
            [inputText]="inputProject.quotation.approvalReasons"
            [extraInstructions]="'Geef hier de reden van afkeuring in'"
            [nullable]="true"
            (answer)="setQuotationApproved($event)"
            (answeredText)="setQuotationApprovalReasons($event)"
          ></yes-no>
          <logged-action-display
            *ngIf="inputProject.quotation?.approvalRegistration != null"
            [inputLoggedAction]="inputProject.quotation.approvalRegistration"
          ></logged-action-display>
        </div>
        <br />
      </div>
      <div *ngFor="let invoice of inputProject.projectInvoices">
        <div *ngIf="invoiceMatchesType(invoice)">
          <company-invoice
            *ngIf="updateEmitter != null && invoice.id != null"
            [project]="project"
            [inputProject]="inputProject"
            [inputInvoice]="invoice"
            [invoiceType]="getInvoiceType()"
            [involvedCompanies]="involvedCompanies"
            [updateEmitter]="updateEmitter"
            [productAdded]="productAdded"
            [boardPartAdded]="boardPartAdded"
            [standardStickerPartAdded]="standardStickerPartAdded"
            [standardStickerPartDeleted]="standardStickerPartDeleted"
          ></company-invoice>
          <company-invoice
            *ngIf="updateEmitter == null && invoice.id != null"
            [project]="project"
            [inputProject]="inputProject"
            [inputInvoice]="invoice"
            [invoiceType]="getInvoiceType()"
            [involvedCompanies]="involvedCompanies"
            [updateEmitter]="outputInvoice"
            [productAdded]="productAdded"
            [boardPartAdded]="boardPartAdded"
            [standardStickerPartAdded]="standardStickerPartAdded"
            [standardStickerPartDeleted]="standardStickerPartDeleted"
          ></company-invoice>
        </div>
      </div>

      <div class="form-title bold-title">
        Nazicht
      </div>

      <textarea-input
        [title]="'Opmerkingen facturatie'"
        [placeholder]="'Calculator: noteer info voor de offerte hier'"
        [initContent]="inputProject.extraInfoInvoice"
        [sensitive]="true"
        (answer)="extraInfoInvoiceChange($event)"
      ></textarea-input>

      <div class="form-title bold-title">
        Nazicht per product
      </div>

      <div *ngIf="getInvoiceType() !== 'AdjustmentInvoice'">
        <div *ngFor="let product of project.products; let index = index">
          <div class="product-title">{{ getProductLabel(product, index) }}</div>

          <div *ngIf="getInvoiceType() === 'PlacementInvoice'">
            <textarea-input
              [title]="'Info plaatsing'"
              [placeholder]="
                'Noteer feedback van de klant over de plaatsing hier'
              "
              [initContent]="product.productPlacement?.placementInfoInvoice"
              (answer)="placementInfoInvoiceChange($event, index)"
            ></textarea-input>

            <ng-container *ngIf="product.productPlacement?.visibleDamage">
              <div class="under-space">
                <div class="form-sub-title">Zichtbare schade aan ramen</div>
                <span class="preserve-line-break"
                  >{{
                    product.productPlacement.extraInfoVisibleDamage
                      | or: 'Geen informatie beschikbaar'
                  }}
                </span>
              </div>
            </ng-container>

            <div class="form-sub-title">Feedback installateur</div>
            <span class="preserve-line-break">{{
              displayInstallerFeedback(product)
            }}</span>
          </div>

          <div class="small-upper-space">
            <mat-checkbox
              [checked]="canInvoiceChecked(product)"
              (change)="readyToInvoiceChange($event, index)"
              >Klaar voor facturatie
            </mat-checkbox>
          </div>
        </div>
      </div>

      <div class="send-button">
        <button
          type="button"
          (click)="sendInvoices(true)"
          mat-button
          class="button"
          [disabled]="
            !canSendInvoices ||
            sendingInvoices ||
            loadingService.getIsSaving() ||
            hasNoInvoices() ||
            !needsInvoice()
          "
          id="btnSendInvoice"
        >
          {{ getSendButtonLabel() }}
        </button>
      </div>

      <div *ngIf="isTestEnvironment()" class="send-button">
        <button
          type="button"
          (click)="sendInvoices(false)"
          mat-button
          class="button"
          id="btnSimulateSendInvoice"
        >
          Simuleer aanmaak factuur
        </button>
      </div>

      <br />

      <div *ngIf="anySentToTeamleader">
        <div class="form-title bold-title">
          Link naar factuur in Teamleader
        </div>

        <ul class="list-top">
          <div *ngFor="let invoice of inputProject.projectInvoices">
            <div
              *ngIf="
                invoiceMatchesType(invoice) && invoice.teamleaderId != null
              "
            >
              <li>
                <a
                  href="https://app.teamleader.eu/invoice_detail.php?id={{
                    invoice.teamleaderId
                  }}"
                  target="_blank"
                  >{{ getLinkText(invoice) }}</a
                >
              </li>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </mat-card>
</div>
